export default __webpack_public_path__ + "static/media/stripe_methods.fd05c9b2.png";